import Delivery from "./Delivery.vue";
import DeliveryAddAddress from "./DeliveryAddAddress.vue";
import CartDetail from "./CartDetail.vue";
import OrderComplete from "./OrderComplete.vue";
import OrderConfirm from "./OrderConfirm.vue";
import Payment from "./Payment.vue";
import ProductDetail from "./ProductDetail.vue";
import Products from "./Products.vue";

export default {
  routes: [
    {
      path: "/products",
      component: Products,
    },
    {
      path: "/products/:productNo",
      component: ProductDetail,
    },
    {
      path: "/cart",
      component: CartDetail,
    },
    {
      path: "/cart/delivery",
      component: Delivery,
    },
    {
      path: "/cart/delivery/addaddress",
      component: DeliveryAddAddress,
    },
    {
      path: "/cart/payment",
      component: Payment,
    },
    {
      path: "/cart/confirm",
      component: OrderConfirm,
    },
    {
      path: "/cart/complete",
      component: OrderComplete,
    },
  ],
};
